@let _dzBankConfiguration = cardInformation()!;
@let _cardProductTexts = cardProductTexts()!;
@let _customData = customData()!;
@let _customer = customer()!;
@let _ibanAnonymised = ibanAnonymised()!;
@if (_dzBankConfiguration && _cardProductTexts && _customData && _customer && _ibanAnonymised) {
  <ez-main-layout [theme]="Themes.NONE">
    <div class="content">
      <ez-stepper></ez-stepper>

      <div class="block--centered block--colored" id="creditCardOverview">
        <h1>Antragsübersicht</h1>
        <p>Um die Kreditkarte zu beantragen, benötigen wir weitere Informationen von Ihnen</p>
        <ez-credit-card-image></ez-credit-card-image>
        <h2 class="text--bold">{{ _cardProductTexts.cardName }}</h2>
        <p id="cardPriceDescription">
          <span
            >{{ _cardProductTexts.priceLabel }} ({{ _dzBankConfiguration.cardType }}) beläuft sich
            {{ isMonthlyCardPrice(_dzBankConfiguration.cardPrice) ? 'monatlich' : 'jährlich' }}</span
          >
          @for (footnote of cardPriceFootnotes(_dzBankConfiguration.cardPrice); track footnote.marker) {
            <sup
              ><span class="visually-hidden"> Fußnote </span>{{ footnote.marker
              }}<span aria-hidden="true">{{ $last ? '' : ',' }}</span></sup
            >
          }
          <span> auf</span>
        </p>
        <p class="text--bold" id="price">
          {{ _dzBankConfiguration.cardPrice.amount | currency: '€' : 'code' : '1.2-2' }}
        </p>
        <ez-card-price-footnotes [cardPrice]="_dzBankConfiguration.cardPrice" />
      </div>

      <div id="deliveryAddress" class="block--colored">
        <h2>Lieferadresse Ihrer Kreditkarte</h2>
        <p>
          {{ _customer.deliveryAddress.street }}, {{ _customer.deliveryAddress.postalCode }}
          {{ _customer.deliveryAddress.city }}
        </p>
      </div>

      <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div id="billingAccountInfo" class="block--colored">
          <h2>Abrechnungskonto Ihrer Kreditkarte</h2>

          <ez-bank-account-info
            [iban]="_ibanAnonymised"
            [customerName]="_customer.firstName + ' ' + _customer.lastName"
            [logoUrl]="smallLogoUrl()"
            [companyName]="organisation()?.name"
          />

          @if (sepaText(); as _sepaText) {
            <ez-expandable-checkbox
              [controlName]="SEPA_ACCEPTED_CONTROL_NAME"
              label="SEPA-Lastschriftmandat erteilen"
              name="sepa-checkbox"
              [altText]="_sepaText.alt"
              [required]="true"
            >
              <p class="text--small preview">{{ _sepaText.preview }}</p>
              <p style="font-weight: normal">{{ _sepaText.expanded }}</p>
            </ez-expandable-checkbox>
          }
        </div>

        <div id="emailContainer" class="block--colored">
          <h2 id="emailLabel">E-Mail-Adresse<span aria-hidden="true">&nbsp;*</span></h2>
          <ez-email-input name="email" [controlName]="EMAIL_CONTROL_NAME" labelledBy="emailLabel"></ez-email-input>
          @if (showPopover() && infoButtonEl) {
            <ez-popover class="popover-component" [referenceEl]="infoButtonEl" (outsideClick)="showPopover.set(false)">
              <p>{{ feeInfoText }}</p>
            </ez-popover>
          }
          <span class="inline--padded">
            Sollten Sie Informationen zum Währungsumrechnungsentgelt
            <ez-info-button class="info-button" (clickEvent)="showPopover.set(!showPopover())" #infoButton />
            per SMS wünschen oder auf die Information verzichten wollen, können Sie sich jederzeit an unseren
            Kundensupport wenden.
          </span>
        </div>

        <div id="mandatoryDeclarations" class="block--colored">
          <h2>SCHUFA-Hinweis</h2>
          <ez-expandable
            header="Datenübermittlung an die SCHUFA und Befreiung vom Bankgeheimnis"
            headerFontWeight="normal"
          >
            <p class="text--small preview">{{ schufaText.preview }}</p>
            <p style="font-weight: normal">{{ schufaText.expanded }}</p>
          </ez-expandable>

          <h2>Erforderliche Erklärungen</h2>
          <ez-expandable-checkbox
            [controlName]="BANKINFO_ACCEPTED_CONTROL_NAME"
            label="Ermächtigung zur Erteilung einer Bankauskunft"
            name="bank-info"
            [altText]="bankInfoText.alt"
            [required]="true"
          >
            <p class="text--small preview">{{ bankInfoText.preview }}</p>
            <p style="font-weight: normal">{{ bankInfoText.expanded }}</p>
          </ez-expandable-checkbox>

          <ez-expandable-checkbox
            [controlName]="MONEY_LAUNDERING_ACCEPTED_CONTROL_NAME"
            label="Angabe nach §3 Geldwäsche&shy;gesetz"
            name="money-laundering"
            [altText]="moneyLaunderingText.alt"
            [required]="true"
          >
            <p class="text--small preview">{{ moneyLaunderingText.preview }}</p>
            <p style="font-weight: normal">{{ moneyLaunderingText.expanded }}</p>
          </ez-expandable-checkbox>
        </div>

        <ez-required-fields-hint></ez-required-fields-hint>
        <ez-button
          [disabled]="!(form && form.valid)"
          [loading]="submitEmailAndAcceptedFieldsRequestIsLoading()"
          class="block--centered"
          label="Weiter"
          maxWidth="450px"
          altText="Wenn Sie das Sepa Mandat erteilt, die E-Mail-Adresse eingegeben und die erforderlichen Erklärungen abgegeben haben, klicken Sie hier auf das orangene Rechteck, um weiter zu kommen"
        ></ez-button>
      </form>
      <p>Mit dem Klicken des Buttons erhalten Sie einen persönlichen Verifizierungscode per E-Mail.</p>
    </div>
  </ez-main-layout>
}
